<template>
  <div id="cover" class="h-screen bg-image bg-cover bg-center flex items-center justify-center text-center">
    <div class="w-auto absolute rounded-lg bottom-10 px-10 text-white dark:text-gray-300">
      <p class="tracking-widest uppercase font-title-hero">{{ 'title' | lang('cover') }}</p>
      <p class="font-subtitle-hero">{{ 'subtitle-name' | lang('cover') }}</p>
      <p class="font-subtitle-hero">{{ 'subtitle-cta' | lang('cover') }}</p>
      <button class="button-cta inline-block relative focus:outline-none color-button-hero
        text-center font-button-hero uppercase box-border rounded-md border"
        @click="onShowMore()">
        {{ 'button' | lang('cover') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onShowMore() {
      this.$emit('selected', 'resume');
    }
  },
}
</script>

<style scoped>
.bg-image {
  background-image: url('../assets/hero-cover.jpg');
}

.button-cta {
  padding:0.7em 1.4em;
  margin:1em 0.3em 0.3em 0;
  box-shadow:inset 0 -0.6em 0 -0.35em rgba(0,0,0,0.17);
}

.button-cta:active{
  top:0.1em;
}

.font-title-hero {
  @apply text-3xl hd:text-4xl fhd:text-5xl 4k:text-8xl;
}

.font-subtitle-hero {
  @apply text-lg hd:text-2xl fhd:text-3xl 4k:text-7xl;
}

.font-button-hero {
  @apply text-sm hd:text-base fhd:text-xl 4k:text-5xl;
}

.color-button-hero {
  @apply hover:text-gray-900 dark:hover:text-blue-300 border-white hover:bg-gray-200 dark:hover:bg-gray-900 dark:border-gray-300 dark:hover:border-gray-900 ;
}
</style>
